export default {"src":"/_next/static/media/iconEdit.d3498448.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};